import { useNavigate as ImportUseNavigate } from "react-router-dom";

export const useNavigate = ImportUseNavigate;